import React, { Suspense } from 'react';
import {
    createHashRouter,
  } from "react-router-dom";
import _ from 'lodash';
import MainPage from './page/MainPage';

// import NoticePage from './page/NoticePage';
// import NoticePreview from './page/NoticePreview';

// 开标
// import BidOpen from 'components/BidOpen';
//登记
import Register from './page/Register';
// import PurchaserRegister from './page/Register/purchaser';
// import AgencyRegister from './page/Register/agency';
// import ExpertRegister from './page/Register/expert';
// import ExpertLeavePage from './page/Register/expertLeave';
// 登录
import Login from './page/Login';
import YDlogin from './page/ydLogin';
import GClogin from './page/gcLogin';
import ExpertLogin from './page/ExpertLogin';
import LuyiLogin from './page/Luyi';
import Bjzb from './page/Bjzb'
// import KaiHong from './page/kaihong'
//中国国际工程咨询有限公司登录页
import Ciecc from './page/Ciecc';   
//忘记密码
// import Forget from './page/Forget';
//关于我们
// import About from './page/About';
/*
import Faq from './page/Faq';
import Property from './page/Property';


//金融服务
import LoanList from './page/LoanList';
import Loan from './page/Loan';
import Loanzr from './page/Loanzr'; 
//平台新闻
import News from './page/News';
//知识库
import Know from './page/Know';
//平台详情
import NewsDetail from './page/NewsDetail';
// 公示询价调研
import Inquiry from "./page/Inquiry"
// 公示询价调研-详情
import InquiryDetail from "./page/InquiryDetail"
import OpenFileViewer from 'components/OpenFileViewer';
import WpsFileViewer from 'components/WpsFileViewer';
import NetcaPDFViewer from 'components/NetcaPDFViewer';
import NetcaPDFnoKeyViewer from 'components/NetcaPDFnoKeyViewer';

//通知书查询
import BookCheck from 'components/BookCheck';
//帮助中心
import Help from './page/Help';
//智采学堂
import ClassRoom from './page/Classroom';
//搜索结果
import Search from './page/Search';
//Ai智能问答
import AiAsk from './page/AiAsk';
//线下报名
import ProjectInfoPage from './page/ProjectInfoPage';
import AuthPage from './page/AuthPage';
import ContractDetail from './page/ContractDetail';
import PurchaseIntentionDetail from './page/PurchaseIntentionDetail';
import EnterprisePage from './page/EnterprisePage';
import EnterpriseBaseInfoPage from './page/EnterpriseBaseInfoPage';
import EnterpriseScaleInfoPage from './page/EnterpriseScaleInfoPage';
import EnterpriseRelationGraphPage from './page/EnterpriseRelationGraphPage';

//医价网
import MedicalHome from "./page/Medical";   //医疗首页
import MedicalPriceNetwork from './page/MedicalPriceNetwork';
import PriceDetail from './page/MedicalPriceNetwork/detail';
import PersonCertSignatureCollection from "./page/PersonCertSignatureCollection";
import OnlineConsumables from './page/MedicalPriceNetwork/winBidPrice/onlineConsumables';
import MedicineCategory from './page/MedicalPriceNetwork/WinBidPrice/medicineCategory';
import MaintenanceCategory from './page/MedicalPriceNetwork/WinBidPrice/maintenanceCategory';
import MedicalDeviceCategory from './page/MedicalPriceNetwork/EquipmentStandard/medicalDeviceCategory';
import SoftwareCategory from './page/MedicalPriceNetwork/WinBidPrice/softwareCategory';
import DeviceRegistration from './page/MedicalPriceNetwork/EquipmentStandard/deviceRegistration';
import MedicalInsuranceItemCode from './page/MedicalPriceNetwork/EquipmentStandard/medicalInsuranceItemCode';
import MedicalConsumablesCode from './page/MedicalPriceNetwork/EquipmentStandard/medicalConsumablesCode';
import MedicalReagentCode from './page/MedicalPriceNetwork/EquipmentStandard/medicalReagentCode';
import DrugCode from './page/MedicalPriceNetwork/EquipmentStandard/drugCode';
import DiseaseICD11Code from './page/MedicalPriceNetwork/EquipmentStandard/diseaseICD11Code';
import SelectSupplier from './page/MedicalPriceNetwork/SelectSupplier';
import SelectHospital from './page/MedicalPriceNetwork/SelectHospital';
import MedicalChargesPublicNotice from './page/MedicalPriceNetwork/MedicalChargesPublicNotice';
import MarketAnalysis from './page/MedicalPriceNetwork/MarketAnalysis';
import ElectronicGuarantee from './page/ElectronicGuarantee';
import ElectronicGuaranteeDetail from './page/ElectronicGuarantee/detail';

*/

// 1. 定义一个通用的加载组件（可选，防止页面切换时白屏）
const PageLoader = (importFunc) => {
  const Component = React.lazy(importFunc);
  return (
    <Suspense fallback={<div className="loading-global">页面加载中...</div>}>
      <Component />
    </Suspense>
  );
};

export default createHashRouter([
  {
    path: "/",
    element: <MainPage />,
  },
  {
    path: "/notice-more/:noticeClassfiyId/:typeId/:typesId",
    element: PageLoader(() => import("./page/NoticePage")),
  },
  {
    path: "/notice-detail/:noticeId",
    element: PageLoader(() => import("./page/NoticeDetail")),
  },
  {
    path: "/notice-preview/:noticeId",
    element:  PageLoader(() => import("./page/NoticePreview")),
  },
  {
    path: "/notice-detail/:noticeId/:openModal",
    element: PageLoader(() => import("./page/NoticeDetail")),
  },
  // 开标
  {
    path: "/bid-open/:bidId",
    element: PageLoader(() => import("./components/BidOpen")),
  },
  //供应商登记
  {
    path: "/register",
    element: <Register />,
  },
  //采购人登记
  {
    path: "/purchaserRegister",
    element: PageLoader(() => import("./page/Register/purchaser")),
  },
  //代理机构登记
  {
    path: "/agencyRegister",
    element: PageLoader(() => import("./page/Register/agency")),
  },
  //专家登记
  {
    path: "/expertRegister",
    element: PageLoader(() => import("./page/Register/expert")),
  },
  //专家请假
  {
    path: "/expertLeave",
    element: PageLoader(() => import("./page/Register/expertLeave")),
  },
  // 登录
  {
    path: "/login",
    element: <Login />,
  },
  //中国国际工程咨询有限公司登录页
  {
    path: "/ciecc",
    element: <Ciecc />,
  },
  //中国远东国际招标有限公司登录页
  {
    path: "/ydlogin",
    element: <YDlogin />,
  },
  {
    path: "/gclogin",
    element: <GClogin />,
  },
  {
    path: "/expertlogin",
    element: <ExpertLogin />,
  },
  {
    path: "/luyilogin",
    element: <LuyiLogin />,
  },
  //北京国际招标有限公司登录页
  {
    path: "/bjzb",
    element: <Bjzb />,
  },
  {
    path: "/kaihong",
    element:PageLoader(() => import("./page/KaiHong")),
  },
  {//忘记密码
    path: "/forget",
    element: PageLoader(() => import("./page/Forget")),
  },
  {//金融服务
    path: "/loanlist",
    element: PageLoader(() => import("./page/LoanList")),
  },
  {//金融服务
    path: "/loan",
    element: PageLoader(() => import("./page/Loan")),
  },
  {//中融金融服务
    path: "/loanzr",
    element: PageLoader(() => import("./page/Loanzr")),
  },
  {//关于我们
    path: "/about",
    element:PageLoader(() => import("./page/About")),
  },
  {//知识产权
    path: "/property",
    element: PageLoader(() => import("./page/Property")),
  },
  {//平台公告
    path: "/plantnotice",
    element: PageLoader(() => import("./page/PlantNotice")),
  },
  {//常见问题
    path: "/faq",
    element: PageLoader(() => import("./page/Faq")),
  },
  {//平台新闻
    path: "/news/:id/:name",
    element: PageLoader(() => import("./page/News")),
  },
  {//新闻详情
    path: "/newsDetail/:id/:tName",
    element: PageLoader(() => import("./page/NewsDetail")),
  },
  {//公示询价调研
    path: "/inquiry/:publicType",
    element:PageLoader(() => import("./page/Inquiry")),
  },
  {//公示询价调研-详情
    path: "/inquiryDetail/:id",
    element: PageLoader(() => import("./page/InquiryDetail")),
  },
  {//公示询价调研-详情-参与
    path: "/inquiryDetail/:id/:showJoinFrom",
    element: PageLoader(() => import("./page/InquiryDetail")),
  },
  {//通知书查询
    path: "/bookcheck",
    element: PageLoader(() => import("./components/BookCheck")),
  },
  {//帮助中心
    path: "/help",
    element: PageLoader(() => import("./page/Help")),
  },
  {//公告搜索
    path: "/search",
    element: PageLoader(() => import("./page/Search")),
  },
  {//Ai智能搜索
    path: "/aiask",
    element: PageLoader(() => import("./page/AiAsk")),
  },
  {//智采学堂
    path: "/classroom",
    element: PageLoader(() => import("./page/ClassRoom")),
  },
  {//知识库
    path: "/know/:id/:name",
    element: PageLoader(() => import("./page/Know")),
  },
  {
    path: "/fileViewer",
    element:PageLoader(() => import("./components/OpenFileViewer")),
  },
  {
    path: "/wpsFileViewer",
    element: PageLoader(() => import("./components/WpsFileViewer")),
  },
  {//线下报名授权页
    path: "/authPage/:id",
    element: PageLoader(() => import("./page/AuthPage")),
  },
  {//线下报名授权页
    path: "/authPage",
    element:PageLoader(() => import("./page/AuthPage")),
  },
  {//线下报名界面
    path: "/projectInfoPage",
    element: PageLoader(() => import("./page/ProjectInfoPage")),
  },
  {
    path: "/netcaPDFViewer/:id",
    element: PageLoader(() => import("./components/NetcaPDFViewer")),
  },
  {
    path: "/NetcaPDFnoKeyViewer/:data",
    element: PageLoader(() => import("./components/NetcaPDFnoKeyViewer")),
  },
  {
    path: "/contract-detail/:id",
    element:PageLoader(() => import("./page/ContractDetail")),
  },
  {
    path: "/purchase-intention-detail/:id",
    element: PageLoader(() => import("./page/PurchaseIntentionDetail")),
  },
  {
    path: "/enterprise",
    element: PageLoader(() => import("./page/EnterprisePage")),
  },
  {
    path: "/enterprise/baseinfo/:id",
    element: PageLoader(() => import("./page/EnterpriseBaseInfoPage")),
  },
  {
    path: "/enterprise/scaleinfo/:id",
    element: PageLoader(() => import("./page/EnterpriseScaleInfoPage")),
  },
  {
    path: "/enterprise/relationgraph/:id",
    element: PageLoader(() => import("./page/EnterpriseRelationGraphPage")),
  },
  {// 医疗首页
    path: "/medicalindex",
    element:PageLoader(() => import('./page/Medical')),
  },
  {//医价网
    path:"/medicallist",
    element:PageLoader(() => import("./page/MedicalPriceNetwork")),
  },
  {//医价网查中标价：设备-价格
  path: "/medical-price-detail/:productXinghaoId",
  element: PageLoader(() => import("./page/MedicalPriceNetwork/detail")),
  },
  {// 医价网查中标价：挂网耗材/试剂
    path: "/MedicalPriceNetwork/onlineConsumables",
    element: PageLoader(() => import("./page/MedicalPriceNetwork/WinBidPrice/onlineConsumables")),
  },
  {//医价网查中标价：药品类
    path: "/medicineCategory",
    element:PageLoader(() => import("./page/MedicalPriceNetwork/WinBidPrice/medicineCategory")),
  },
  {//医价网查中标价：维保类
    path: "/maintenanceCategory",
    element:PageLoader(() => import("./page/MedicalPriceNetwork/WinBidPrice/maintenanceCategory")),
  },
  {//医价网查中标价：软件类
    path: "/softwareCategory",
    element: PageLoader(() => import("./page/MedicalPriceNetwork/WinBidPrice/softwareCategory")),
  },
  {//医价网查器械标准：医用器械分类
    path:"/medicalDeviceCategory",
    element:PageLoader(() => import("./page/MedicalPriceNetwork/EquipmentStandard/MedicalDeviceCategory")),
  },
  {//医价网查器械标准：器械注册证
    path:"/deviceRegistration",
    element:PageLoader(() => import("./page/MedicalPriceNetwork/EquipmentStandard/DeviceRegistration")),
  },
  {//医价网查器械标准：医保项目编码
    path: "/medicalInsuranceItemCode",
    element: PageLoader(() => import("./page/MedicalPriceNetwork/EquipmentStandard/MedicalInsuranceItemCode")),
  },
  {//医价网查器械标准：医用耗材编码
    path: "/medicalConsumablesCode",
    element: PageLoader(() => import("./page/MedicalPriceNetwork/EquipmentStandard/MedicalConsumablesCode")),
  },
  {//医价网查器械标准：医用试剂编码
    path: "/medicalReagentCode",
    element: PageLoader(() => import("./page/MedicalPriceNetwork/EquipmentStandard/medicalReagentCode")),
  },
  {//医价网查器械标准：药品编码
    path: "/drugCode",
    element: PageLoader(() => import("./page/MedicalPriceNetwork/EquipmentStandard/DrugCode")),
  },
  {//医价网查器械标准：疾病ICD11编码
    path: "/diseaseICD11Code",
    element: PageLoader(() => import("./page/MedicalPriceNetwork/EquipmentStandard/DiseaseICD11Code")),
  },
  {//医价网查供应商
    path: "/selectSupplier",
    element: PageLoader(() => import("./page/MedicalPriceNetwork/SelectSupplier")),
  },
  {//医价网查医院
    path: "/selectHospital",
    element:PageLoader(() => import("./page/MedicalPriceNetwork/SelectHospital")),
  },
  {//医价网医疗收费公示
    path: "/medicalChargesPublicNotice",
    element: PageLoader(() => import("./page/MedicalPriceNetwork/MedicalChargesPublicNotice")),
  },
  {//医价网市场分析
    path: "/marketAnalysis",
    element: PageLoader(() => import("./page/MedicalPriceNetwork/MarketAnalysis")),
  },
  {//电子保函
    path: "/electronicGuarantee",
    element: PageLoader(() => import("./page/ElectronicGuarantee")),
  },
  {//电子保函详情
    path: "/electronicGuarantee/detail/:id",
    element: PageLoader(() => import("./page/ElectronicGuarantee/detail")),
  },
  {// 专家信息采集
    path:"/e/:ytenantId",
    element:PageLoader(() => import("./page/PersonCertSignatureCollection")),
  },
  {// 重大项目详情
    path:"/bigProjectDetail/:id",
    element: PageLoader(() => import('./page/BigProjectDetail')),
  },


]);
